import React, { useRef, useEffect } from 'react';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

function YouTubePlayer({ videoId }) {
    const playerRef = useRef(null);
    const playerInstance = useRef(null);

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        // Initialize the array for pending YouTube players, if it doesn't exist.
        if(!window.youtubePlayersToInitialize) {
            window.youtubePlayersToInitialize = [];
        }

        // Push our createPlayer function to the array.
        window.youtubePlayersToInitialize.push(createPlayer);

        // Check if YouTube API is loaded.
        if (window.YT && window.YT.Player) {
            createPlayer();
        } else {
            // If not, set the global onYouTubeIframeAPIReady to process the array.
            window.onYouTubeIframeAPIReady = function() {
                window.youtubePlayersToInitialize.forEach(fn => fn());
            };
        }

        // Ensure the YouTube API script is loaded.
        if (!window.YT) {
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            document.body.appendChild(script);
        }

        return () => {
            // Cleanup: Remove the createPlayer function from the array.
            const index = window.youtubePlayersToInitialize.indexOf(createPlayer);
            if (index > -1) {
                window.youtubePlayersToInitialize.splice(index, 1);
            }
        };

    }, [videoId]);

    const createPlayer = () => {
        playerInstance.current = new window.YT.Player(playerRef.current, {
            videoId: videoId,
            events: {
                onStateChange: handlePlayerStateChange
            }
        });
    };

    useEffect(() => {
        if (karmaContext.contentPlayingManager.currentlyPlayingContent.id !== videoId)
        {
            pauseVideo();
        }
    }, [karmaContext.contentPlayingManager.currentlyPlayingContent.id, videoId]);

    const handlePlayerStateChange = (event) => {
        if (event.data === window.YT.PlayerState.PLAYING) {
            console.log("YouTube: currentlyPlayingContent: " + karmaContext.contentPlayingManager.currentlyPlayingContent.id);
            console.log("YouTube: videoId: " + videoId);
            karmaContext.contentPlayingManager.setCurrentlyPlayingContent({id: videoId, type: "YOUTUBE"});
        }
    };

    const pauseVideo = () => {
        if (playerInstance.current && playerInstance.current.pauseVideo) {
            playerInstance.current.pauseVideo();
        }
    };

    return (
        <div>
            <iframe
                ref={playerRef}
                src={"https://www.youtube.com/embed/" + videoId + "?enablejsapi=1"}
                title={"YouTube Video Player - " + videoId}
                frameBorder="0"
            ></iframe>
        </div>
    );
}

export default YouTubePlayer;
